import _ from "lodash";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import FeatureIcon from "FeatureIcon";
import { connect } from "react-redux";
import { createEvent } from "EventActions";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm } from "redux-form";

// change everything to redux form

class SignupFeatures extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onEventInputChange = this.onEventInputChange.bind(this);
    this.state = {
      eventname: "",
      features: [
        {
          displaytabname: "Schedule",
          tabslected: "schedule",
          iconimagepath: "",
        },
        { displaytabname: "Maps", tabslected: "maps", iconimagepath: "" },
        {
          displaytabname: "Speakers",
          tabslected: "speaker",
          iconimagepath: "",
        },
        {
          displaytabname: "Sponsors",
          tabslected: "sponsor",
          iconimagepath: "",
        },
        {
          displaytabname: "Exhibitors",
          tabslected: "exhibitor",
          iconimagepath: "",
        },
        {
          displaytabname: "Messages",
          tabslected: "message",
          iconimagepath: "",
        },
        { displaytabname: "Social", tabslected: "social", iconimagepath: "" },
        { displaytabname: "News", tabslected: "news", iconimagepath: "" },
        { displaytabname: "About", tabslected: "about", iconimagepath: "" },
        {
          displaytabname: "Web-View",
          tabslected: "webview",
          iconimagepath: "",
        },
      ],
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  onEventInputChange(event) {
    this.setState({ eventname: event.target.value });
  }

  renderField(field) {
    var {
      meta: { touched, error },
    } = field;
    var className = `form-group signup-element ${
      touched && error ? "has-danger" : ""
    }`;
    return (
      <div className={className}>
        <input
          className="form-control center"
          type={field.type}
          placeholder={field.placeholder}
          {...field.input}
        />
        <div className="text-help">{touched ? error : ""}</div>
      </div>
    );
  }

  onFormSubmit(values) {
    //event.preventDefault();

    this.props.createEvent(
      values.eventname,
      this.props.signupSelectedFeature,
      this.props.user,
      this.props.session,
      (response) => {
        if (response.success === 1) {
          // event creation is successful
        } else {
        }
      }
    );
  }

  renderFeaturesIcons() {
    return _.map(this.state.features, (feature) => {
      return <FeatureIcon key={feature.tabslected} feature={feature} />;
    });
  }

  render() {
    var { handleSubmit } = this.props;
    return (
      <form
        onSubmit={handleSubmit(this.onFormSubmit)}
        ref="form_features"
        className="steps-animation"
      >
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6">
            <div className="verify-title">What is your event name?</div>
            <div>
              <Field
                name="eventname"
                placeholder="Event name"
                type="text"
                component={this.renderField}
              />
            </div>
          </div>
          <div className="col-md-3" />
        </div>
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6 horizontal-align-center features-desc">
            Choose the features that you would like to see on your event app
          </div>
          <div className="col-md-3" />
        </div>
        <div className="row">
          <div className="col-md-12">&nbsp;</div>
        </div>
        <div className="row">
          <div className="col-md-1" />
          <div className="col-md-10 features-icons-set">
            {this.renderFeaturesIcons()}
          </div>
          <div className="col-md-1" />
        </div>
        <div className="row">
          <div className="col-md-12">&nbsp;</div>
        </div>
        <div className="row">
          <div className="col-md-12 horizontal-align-center features-dark-color">
            You can always change this later
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">&nbsp;</div>
        </div>
        <div className="row choose-save">
          <div className="col-md-4" />
          <div className="col-md-4">
            <button type="submit" className="btn btn-default btn-social-login">
              Save & Continue
            </button>
          </div>
          <div className="col-md-4" />
        </div>
      </form>
    );
  }
}

function mapStateToProps({ signupSelectedFeature, user, session }) {
  return { signupSelectedFeature, user, session };
}

function validate(values) {
  var errors = {};
  if (!values.eventname) {
    errors.eventname = "Please enter event name";
  }
  return errors;
}

export default reduxForm({
  validate,
  form: "SignupEventCreationForm",
})(connect(mapStateToProps, { createEvent })(SignupFeatures));
